export default "__VITE_ASSET__t6McmGuo__"